import { render, staticRenderFns } from "./LgFinderPageMotivoAgregacao.vue?vue&type=template&id=74249dba"
import script from "./LgFinderPageMotivoAgregacao.vue?vue&type=script&lang=js"
export * from "./LgFinderPageMotivoAgregacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports